import apiClient from '../client';

export interface CustomerInfo {
  Id: number;
  CustomerId: string;
  CustomerName: string;
  AutoCheck: boolean;
  EdiIntegration: boolean;
  Dropship: boolean;
  DropshipCharge: number;
  Freight: number;
  DefaultShippingMethod: number | null;
  PaymentTerm: string;
  CreateBy?: string;
  CreateDate?: Date;
}

export interface CreateCustomerInfoDTO {
  CustomerId: string;
  CustomerName: string;
  AutoCheck?: boolean;
  EdiIntegration?: boolean;
  Dropship?: boolean;
  DropshipCharge?: number;
  Freight?: number;
  DefaultShippingMethod?: number | null;
  PaymentTerm?: string;
}

export interface UpdateCustomerInfoDTO {
  AutoCheck?: boolean;
  EdiIntegration?: boolean;
  Dropship?: boolean;
  DropshipCharge?: number;
  Freight?: number;
  DefaultShippingMethod?: number | null;
  PaymentTerm?: string;
}

export interface ShippingMethod {
  Id: number;
  Name: string;
}

export const customerInfoService = {
  getAllCustomerInfo: async (): Promise<CustomerInfo[]> => {
    const response: any = await apiClient.get('/customer-info');
    return response.data;
  },

  getCustomerInfoById: async (id: number): Promise<CustomerInfo> => {
    const response: any = await apiClient.get(`/customer-info/${id}`);
    return response.data;
  },

  createCustomerInfo: async (data: CreateCustomerInfoDTO): Promise<CustomerInfo> => {
    const response: any = await apiClient.post('/customer-info', data);
    return response.data;
  },

  updateCustomerInfo: async (id: number, data: UpdateCustomerInfoDTO): Promise<CustomerInfo> => {
    const response: any = await apiClient.put(`/customer-info/${id}`, data);
    return response.data;
  },

  deleteCustomerInfo: async (id: number): Promise<void> => {
    await apiClient.delete(`/customer-info/${id}`);
  },

  getPaymentTerms: async (): Promise<string[]> => {
    const response: any = await apiClient.get('/customer-info/payment-terms');
    return response.data;
  },

  getShippingMethods: async (): Promise<ShippingMethod[]> => {
    const response: any = await apiClient.get('/customer-info/shipping-methods');
    return response.data;
  },
};
